import { gql } from '@apollo/client';

export const EVM_INSTRUCTION = gql`
  fragment EvmInstruction on EvmInstruction {
    id
    contractId
    treatmentId
    treatment {
      id
      name
      description
      reconOrder
    }
    blockSvcMethodId
    notes
    updatedAt
    chain {
      credentialType
    }
    evmContract {
      address
    }
    evmMethod {
      hash
    }
  }
`;
